import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
interface SectionHeaderProps {
  title: string;
  description?: string;
  link?: {
    label: string;
    to: string;
  };
  id?: string;
  children?: React.ReactNode;
}
export function SectionHeader({
  title,
  description,
  link,
  id,
  children
}: SectionHeaderProps) {
  return <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-417" data-mp="wtz43v1zgsg7">
      <div data-id="element-418" data-mp="1apuhjldm5bc7">
        <h2 id={id} className="text-3xl font-medium tracking-[-0.03em] text-ink lg:text-[40px] lg:leading-[1.1]" data-id="element-419" data-mp="1apkqrvkqv05g">
          {title}
        </h2>
        {description && <p className="mt-2 max-w-lg text-[15px] text-muted" data-id="element-420" data-mp="1kg5jx3hnfcgz">{description}</p>}
      </div>
      <div className="flex items-center gap-6" data-id="element-421" data-mp="1fjf50jhkymx5">
        {children}
        {link && <Link to={link.to} className="group inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-ink" data-id="element-422" data-mp="1thdhtkg96baj">
            <span className="underline-offset-4 group-hover:underline" data-id="element-423" data-mp="1phuw4mglxw6n">{link.label}</span>
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-424" data-mp="3dwbre6747gwt" />
          </Link>}
      </div>
    </div>;
}